import Axios from "axios";
import {
    SET_PUR_RFQ_GEN_REPORT,
    UNSET_PUR_RFQ_GEN_REPORT,
  } from "@/store/mutation-types";
import {getPurRFQGenReport} from "@/store/api";

const state = {
    getPurRFQGenReport: [],
};

const getters = {
    getPurRFQGenReport(state) {
        return state.getPurRFQGenReport;
    },
};

const mutations = {
    [SET_PUR_RFQ_GEN_REPORT](state, data) {
        state.getPurRFQGenReport = data;
    },
    [UNSET_PUR_RFQ_GEN_REPORT](state) {
        state.getPurRFQGenReport = [];
    },
};

const actions = {
    getPurRFQGenReport({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.get(`${getPurRFQGenReport}`, { params: data })
                .then((response) => {
                    commit(SET_PUR_RFQ_GEN_REPORT, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_RFQ_GEN_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

